import React from 'react';

import { Select } from 'antd';

import styled from 'styled-components';

import { useStateValue } from '@contexts/StateProvider';

import CustomSwitch from '@components/Gui/CustomSwitch';
import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const { Option } = Select;

const SwitchContainer = styled.div`
    display: flex;
    align-items: center;

    .title {
        margin-left: 8px;
        margin-right: 16px;
        text-transform: uppercase;
    }

    .ant-select {
        width: auto !important;
        min-width: 200px;
        margin-left: 1em;
    }
`;

const VisibilitySelector = ({ value, onChange }) => {
    const [{ areaContext } /*, dispatch*/] = useStateValue();

    const handleChangeVisibility = (checked) => {
        if (checked) {
            onChange({
                ...value,
                isGlobal: checked,
                Areas: [],
            });
        } else {
            onChange({
                ...value,
                isGlobal: checked,
                Areas: value.Areas.length > 0 ? [...value.Areas] : [areaContext.area],
            });
        }
    };

    const handleClickViewType = (viewType) => {
        onChange({
            ...value,
            Areas: [...viewType],
        });
    };

    return (
        <>
            <SwitchContainer>
                <CustomSwitch
                    checked={value ? value.isGlobal : true}
                    compact
                    type="visibilityarea"
                    onChange={handleChangeVisibility}
                />
                {value && !value.isGlobal && (
                    <Select
                        autoComplete="off"
                        mode="multiple"
                        popupClassName="ant-select-dropdown-areaselect"
                        value={value.Areas}
                        onChange={handleClickViewType}
                        optionLabelProp="label"
                    >
                        <Option value="booking" label="BOOK">
                            <NwIcon
                                color={StyleVariables.PrimaryColor}
                                icon={byPrefixAndName.fasl['heart-rate']}
                                style={{ marginRight: '.6em' }}
                            />
                            BOOKING
                        </Option>
                        <Option value="scouting" label="SCO">
                            <NwIcon
                                color={StyleVariables.PrimaryColor}
                                icon={byPrefixAndName.fasl['globe']}
                                style={{ marginRight: '.6em' }}
                            />
                            SCOUTING
                        </Option>
                        <Option value="accounting" label="ACCT">
                            <NwIcon
                                color={StyleVariables.PrimaryColor}
                                icon={byPrefixAndName.fasl['comment-alt-dollar']}
                                style={{ marginRight: '.6em' }}
                            />
                            ACCOUNTING
                        </Option>
                        <Option value="management" label="MGMT">
                            <NwIcon
                                color={StyleVariables.PrimaryColor}
                                icon={byPrefixAndName.fasl['chart-pie']}
                                style={{ marginRight: '.6em' }}
                            />
                            MANAGEMENT
                        </Option>
                        <Option value="art" label="ART">
                            <NwIcon
                                color={StyleVariables.PrimaryColor}
                                icon={byPrefixAndName.fasl['camera-retro']}
                                style={{ marginRight: '.6em' }}
                            />
                            ART & MARKETING
                        </Option>
                    </Select>
                )}
            </SwitchContainer>
        </>
    );
};

export default VisibilitySelector;
